import Helper from 'dxf/src/Helper'
import colors from 'dxf/src/util/colors'

export default class DXFFile {
    #data
    constructor(data) {
        this.parseData(data);
    }

    parseData(data) {
        var helper = new Helper(data);
        this.#data = this.parseDXFString(data);

        this.groups = helper.groups;
        this.parsed = helper.parsed;
        this.polylines = helper.toPolylines();
    }


    parseDXFString(string) {
        // Parse the value into the native representation
        const parseValue = (type, value) => {
            if (type >= 10 && type < 60) {
                return parseFloat(value, 10)
            } else if (type >= 210 && type < 240) {
                return parseFloat(value, 10)
            } else if (type >= 60 && type < 100) {
                return parseInt(value, 10)
            } else {
                return value
            }
        }

        const headerHandler = (tuples) => {
            for (let i = 0; i < tuples.length; i++) {
                const [type, value] = tuples[i]
                if (value === '$ACADVER' && i + 1 < tuples.length) {
                    const [nextType, acadVer] = tuples[i + 1]
                    if (nextType === 1) {
                        return { acadVer } // Stop parsing immediately
                    }
                }
            }
            return {}
        }

        // Content lines are alternate lines of type and value
        const convertToTypesAndValues = (contentLines) => {
            // ADDED THIS TO QUIT AFTER ACADVER BECAUSE REST ISNT NEEDED YET
            let found = false;

            let state = 'type'
            let type
            const typesAndValues = []
            for (const line of contentLines) {
                if (state === 'type') {
                    type = parseInt(line, 10)
                    state = 'value'
                } else {
                    typesAndValues.push([type, parseValue(type, line)])
                    state = 'type'

                    // ADDED THIS TO QUIT AFTER ACADVER BECAUSE REST ISNT NEEDED YET
                    if (line == '$ACADVER') {
                        found = true;
                    } else if (found && line == 'ENDSEC') {
                        return typesAndValues;
                    }
                }
            }
            return typesAndValues
        }

        const separateSections = (tuples) => {
            let sectionTuples
            return tuples.reduce((sections, tuple) => {
                if (tuple[0] === 0 && tuple[1] === 'SECTION') {
                    sectionTuples = []
                } else if (tuple[0] === 0 && tuple[1] === 'ENDSEC') {
                    sections.push(sectionTuples)
                    sectionTuples = undefined
                } else if (sectionTuples !== undefined) {
                    sectionTuples.push(tuple)
                }
                return sections
            }, [])
        }

        // Each section start with the type tuple, then proceeds
        // with the contents of the section
        const reduceSection = (acc, section) => {
            const sectionType = section[0][1]
            const contentTuples = section.slice(1)
            switch (sectionType) {
                case 'HEADER':
                    acc.header = headerHandler(contentTuples)
                    break
            }
            return acc
        }

        const lines = string.split(/\r\n|\r|\n/g)
        const tuples = convertToTypesAndValues(lines)
        const sections = separateSections(tuples)
        const result = sections.reduce(reduceSection, {
            // Start with empty defaults in the event of empty sections
            header: {},
            // blocks: [],
            // entities: [],
            // objects: { layouts: [] },
            // tables: { layers: {}, styles: {}, ltypes: {} },
        })
        return result
    }

    get acadVer() {
        return this.#data.header.acadVer
    }

    getData() {
        return this.groups;
    }
    getLayerInfo(layername) {
        return this.parsed.tables.layers[layername];
    }
    static getColor(colornumber) {
        return colors[colornumber];
    }

    convertDXF(conversion) {
        //convert groups
        for (let group in this.groups) {
            this.groups[group].forEach(element => {
                if (element.type == "MTEXT") {
                    element.x *= conversion;
                    element.xAxisX *= conversion;
                    element.xAxisY *= conversion;
                    element.xAxisZ *= conversion;
                    element.y *= conversion;
                    element.z *= conversion;
                } else if (element.type == "LWPOLYLINE" || element.type == "POLYLINE" || element.type == "3DFACE") {
                    element.vertices.forEach(vertice => {
                        vertice.x *= conversion;
                        vertice.y *= conversion;
                    });
                } else if (element.type == "LINE") {
                    element.end.x *= conversion;
                    element.end.y *= conversion;
                    element.end.z *= conversion;

                    element.start.x *= conversion;
                    element.start.y *= conversion;
                    element.start.z *= conversion;
                } else if (element.type == "POINT") {
                    element.x *= conversion;
                    element.y *= conversion;
                    element.z *= conversion;
                } else if (element.type == "ARC" || element.type == "CIRCLE") {
                    element.x *= conversion;
                    element.y *= conversion;
                    element.z *= conversion;

                    element.r *= conversion;
                }
            });
        }

        //convert parsed
        this.parsed.blocks.forEach(block => {
            block.x *= conversion;
            block.y *= conversion;
            block.z *= conversion;
        });
        this.parsed.entities.forEach(entity => {
            if (entity.type == "MTEXT") {
                entity.x *= conversion;
                entity.xAxisX *= conversion;
                entity.xAxisY *= conversion;
                entity.xAxisZ *= conversion;
                entity.y *= conversion;
                entity.z *= conversion;
            } else if (entity.type == "LWPOLYLINE" || entity.type == "POLYLINE" || entity.type == "3DFACE") {
                entity.vertices.forEach(vertice => {
                    vertice.x *= conversion;
                    vertice.y *= conversion;
                });
            } else if (entity.type == "LINE") {
                entity.end.x *= conversion;
                entity.end.y *= conversion;
                entity.end.z *= conversion;

                entity.start.x *= conversion;
                entity.start.y *= conversion;
                entity.start.z *= conversion;
            } else if (entity.type == "POINT") {
                entity.x *= conversion;
                entity.y *= conversion;
                entity.z *= conversion;
            } else if (entity.type == "ARC" || entity.type == "CIRCLE") {
                entity.x *= conversion;
                entity.y *= conversion;
                entity.z *= conversion;

                entity.r *= conversion;
            }
        });

        if (this.parsed.header.extMax) {
            this.parsed.header.extMax.x *= conversion;
            this.parsed.header.extMax.y *= conversion;
            this.parsed.header.extMax.z *= conversion;
        }

        if (this.parsed.header.extMin) {
            this.parsed.header.extMin.x *= conversion;
            this.parsed.header.extMin.y *= conversion;
            this.parsed.header.extMin.z *= conversion;
        }

        // convert polylines
        if (this.polylines.bbox) {
            this.polylines.bbox.max.x *= conversion;
            this.polylines.bbox.max.y *= conversion;
            this.polylines.bbox.min.x *= conversion;
            this.polylines.bbox.min.y *= conversion;
        }

        this.polylines.polylines.forEach(polyline => {
            polyline.vertices.forEach(vertice => {
                vertice[0] *= conversion;
                vertice[1] *= conversion;
            });
        });
    }
}